
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4150819a&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TotalPrice.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TotalPrice.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4150819a!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TotalPrice.vue"),
  /* scopeId */
  "data-v-4150819a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TotalPrice.vue
// module id = 372
// module chunks = 0